module.exports = __webpack_public_path__ + "static/media/gerialine.b9b1bf4f.webp";